import { HttpResponse, delay, http } from 'msw';

import { setCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformLoginUserMockHandler = () => {
  return http.post('*/user/login', async (info) => {
    await delay(MOCK_DELAY);

    const body: any = await info.request.json();

    if (body?.id_token) {
      setCustomHandlerLoginStatus(true);

      return new HttpResponse(null, {
        status: 204,
      });
    }

    return HttpResponse.json(
      {
        message: 'Invalid id_token',
      },
      { status: 401 },
    );
  });
};
